import { useUiStore } from '../../stores/uiStore';
import { ToastContainer } from '../ui/Toast';

const VARIANT_TO_TYPE = {
  success: 'success',
  error: 'error',
  info: 'info',
  warning: 'warning',
} as const;

export function UiStoreToastBridge() {
  const toasts = useUiStore((s) => s.toasts);
  const removeToast = useUiStore((s) => s.removeToast);

  return (
    <ToastContainer
      toasts={toasts.map((t) => ({
        id: t.id,
        type: VARIANT_TO_TYPE[t.variant],
        title: t.title,
        message: t.description || undefined,
      }))}
      remove={removeToast}
    />
  );
}
